var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_321_895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3323 0.555664H10.6347C5.06796 0.555664 0.539062 5.08456 0.539062 10.6513V24.3489C0.539062 29.9157 5.06796 34.4446 10.6347 34.4446H24.3323C29.8991 34.4446 34.428 29.9157 34.428 24.3489V10.6513C34.4279 5.08456 29.899 0.555664 24.3323 0.555664ZM31.0187 24.3489C31.0187 28.0417 28.0251 31.0353 24.3323 31.0353H10.6347C6.94195 31.0353 3.94828 28.0417 3.94828 24.3489V10.6513C3.94828 6.95849 6.94195 3.96488 10.6347 3.96488H24.3323C28.0251 3.96488 31.0187 6.95849 31.0187 10.6513V24.3489Z",
    fill: "url(#paint0_linear_321_895)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4836 8.73535C12.6507 8.73535 8.71875 12.6673 8.71875 17.5002C8.71875 22.3331 12.6507 26.265 17.4836 26.265C22.3166 26.265 26.2485 22.3331 26.2485 17.5002C26.2485 12.6672 22.3166 8.73535 17.4836 8.73535ZM17.4836 22.8559C14.5258 22.8559 12.128 20.4581 12.128 17.5002C12.128 14.5424 14.5258 12.1446 17.4836 12.1446C20.4415 12.1446 22.8393 14.5424 22.8393 17.5002C22.8393 20.458 20.4414 22.8559 17.4836 22.8559Z",
    fill: "url(#paint1_linear_321_895)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2643 10.9012C27.4242 10.9012 28.3645 9.96086 28.3645 8.80093C28.3645 7.641 27.4242 6.70068 26.2643 6.70068C25.1044 6.70068 24.1641 7.641 24.1641 8.80093C24.1641 9.96086 25.1044 10.9012 26.2643 10.9012Z",
    fill: "url(#paint2_linear_321_895)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_321_895",
    x1: 17.4835,
    y1: 34.3459,
    x2: 17.4835,
    y2: 0.818885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_321_895",
    x1: 17.4836,
    y1: 34.346,
    x2: 17.4836,
    y2: 0.819003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_321_895",
    x1: 26.2643,
    y1: 34.3458,
    x2: 26.2643,
    y2: 0.818773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_321_895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.8889,
    height: 33.8889,
    fill: "white",
    transform: "translate(0.539062 0.555664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.6d6d8ae23316bbd3084f671edfb161bd.svg";
export { ForwardRef as ReactComponent };